document.getElementById("downloadCSV").addEventListener("click", function () {
  let csvContent = "data:text/csv;charset=utf-8,";
  csvContent += "Product Name,Variant Title,SKU,Quantity,Price\n"; // Updated CSV Headers

  async function fetchDataInSequence() {
    document.getElementById("downloadCSV").textContent = "Downloading...";
    try {
      let response1 = await fetch(
        "https://tov-b2b-uk-dealer-portal.myshopify.com/collections/all-products"
      );
      let data1 = await response1.text();
      dataProcessing(data1);

      let response2 = await fetch(
        "https://tov-b2b-uk-dealer-portal.myshopify.com/collections/all-products?page=2"
      );
      let data2 = await response2.text();
      dataProcessing(data2);

      let response3 = await fetch(
        "https://tov-b2b-uk-dealer-portal.myshopify.com/collections/all-products?page=3"
      );
      let data3 = await response3.text();
      dataProcessing(data3);

      let response4 = await fetch(
        "https://tov-b2b-uk-dealer-portal.myshopify.com/collections/all-products?page=4"
      );
      let data4 = await response4.text();
      dataProcessing(data4);

      let response5 = await fetch(
        "https://tov-b2b-uk-dealer-portal.myshopify.com/collections/all-products?page=5"
      );
      let data5 = await response5.text();
      dataProcessing(data5);

      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "wholesale_pricing.csv");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log("Error:", error);
    } finally {
      document.getElementById("downloadCSV").textContent = "Download";
    }
  }

  function dataProcessing(data) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const gridItem = Array.from(
      doc.body.querySelectorAll("#product-grid .grid__item")
    );
    gridItem.forEach(function (item) {
      let productTitle = item.querySelector(".catalog-product-title").innerHTML;
      const variantDataWrapper = item.querySelectorAll(
        ".catalog-variant-data-wrapper"
      );
      variantDataWrapper.forEach(function (variant) {
        let variantTitle = variant.querySelector(
          ".catalog-variant-title"
        ).innerHTML;
        let variantSku = variant.querySelector(
          ".catalog-variant-sku"
        ).innerHTML;
        let variantInventory = variant.querySelector(
          ".catalog-variant-inventory"
        ).innerHTML;
        let variantPrice = variant.querySelector(
          ".catalog-variant-price"
        ).innerHTML;

        csvContent += `${productTitle},${variantTitle},${variantSku},${variantInventory},${variantPrice}\n`;
      });
    });
  }
  fetchDataInSequence();
});
